import { PropsWithChildren, ReactNode } from 'react';
import { QuickSwitchBreadcrumbsNav } from '@dealstack/frontend/shared/components/QuickSwitchBreadcrumbsNav/QuickSwitchBreadcrumbsNav.tsx';
import { Flex, Text } from '@mantine/core';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	pageTitle?: string;
	customTitle?: ReactNode;
	hideBreadcrumbs?: boolean;
	showQuickSwitch?: boolean;
	leftIcon?: React.ReactNode;
}

export const PageHeader = ({
	pageTitle,
	customTitle,
	hideBreadcrumbs,
	showQuickSwitch = true,
	leftIcon,
	children,
}: PropsWithChildren<Props>) => {
	return (
		<Flex direction="column" gap="1rem">
			{!hideBreadcrumbs && <QuickSwitchBreadcrumbsNav showQuickSwitch={showQuickSwitch} />}

			<Flex justify="space-between" gap="1rem">
				<Flex align="center" gap="1rem">
					{leftIcon}

					{pageTitle && (
						<Text data-testid={TEST_ELEMENT_IDS.PAGE_HEADER} size="B3Bold" c="dark.8">
							{pageTitle}
						</Text>
					)}

					{customTitle}
				</Flex>

				{children}
			</Flex>
		</Flex>
	);
};
